













































































































import { Vue, Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import API from "@/Api";
const namespace: string = "AppStore";
@Component
export default class AssignedCourse extends Vue {
  @Getter("role", { namespace }) public role: any;
  @Getter("name", { namespace }) public userName: any;
  public items: any = [];
  public loader: boolean = false;
  public dialog: boolean = false;
  public file: any = "";
  public id: number = 0;
  public isDocumentUpload: boolean = false;
  public certificates: any = [];
  public hasCodeTableLoaded: boolean = false;

  public eid: any = null;
  public Coursename: any = '';
  public Platform: any = '';
  public Courselink: any = '';
  public Duration: any = '';
  public Amount: any = '';
  public Timeline: any = '';
  public contentid: any = '';
  public certificateurl: any = '';
  public courserecommendlink: any ='';
  public coursetimeline: any ='';
  
  

  public fdcontentid: any = '';
  public fdcontentidaaray: any = [];

  
  public openDocumentUpload(fdcontentid: any) {
    this.isDocumentUpload = true;
    this.fdcontentid=fdcontentid;
  console.log(fdcontentid);

  }
  public dropDownList: any = [
    // {
    //   id: 0,
    //   name: "Unknown",
    // },
    {
      id: 1,
      name: "Yet to Start",
    },
    {
      id: 2,
      name: "In Progress",
    },
    {
      id: 3,
      name: "Completed",
    },
  ];

  public created()
  {
    console.log("test::");
    this.loadDatav2();
  }

  public mounted() {
    this.eid = this.$route.params.id;
    console.log(this.eid);


  console.log("2::");

  
    console.log("3::");
      this.loadDatav2();
    


  }

  public loadData() {
    console.log("111");
    API.Instance.get('/api/trainingplans/getInfo').then((respone) => {
     
      this.items = respone.data;
      
    });
  }

  public loadDatav2() {
    console.log("2222");
    API.Instance.get('api/trainingplans/getInfobyhr?eid='+this.eid).then((response) => {     
    
      this.items = response.data;
      
    });
  }

  public load() {
    console.log("33333");
    this.loader = true;
    API.Instance.get("/api/assigned-courses").then((response) => {
      this.items = response.data;
      this.loader = false;
    });
  }
  
  public openDialog(id: any) {
    this.dialog = true;
    this.id = id;
   
  }


  public trainplanhandleFileUpload(event: any) {
    
// upload-certificate
this.file = event.target.files;
console.log(event.ref);
const formData = new FormData();
for (let x = 0; x < this.file.length; x++) {
  formData.append("file" + x, this.file[x]);
}
if (this.file.length > 0) {
  API.Instance.post("/api/assigned-courses/upload-certificate", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
    .then((response) => {
      this.$store.commit("AppStore/SNACK_BAR", {
        text: `File has been uploaded successfully!`,
        show: true,
      });
      this.file = null;

      
      
this.items[this.fdcontentid].certificateurl=response.data;

      

    })
    .catch(() => {
      this.$store.commit("AppStore/SNACK_BAR", {
        text: `Can't upload the given file, Please check the content!`,
        show: true,
      });
    });
}
console.log(this.certificates);
console.log(this.items);


}


  public handleFileUpload(event: any) {
    if (!this.isDocumentUpload) {
      this.file = event.target.files;
      const formData = new FormData();
      for (let x = 0; x < this.file.length; x++) {
        formData.append("file" + x, this.file[x]);
      }
      if (this.file.length > 0) {
        API.Instance.post("/api/assigned-courses/upload-data", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            this.$store.commit("AppStore/SNACK_BAR", {
              text: `File has been uploaded successfully!`,
              show: true,
            });
            this.file = null;
            this.load();
          })
          .catch(() => {
            this.$store.commit("AppStore/SNACK_BAR", {
              text: `Can't upload the given file, Please check the content!`,
              show: true,
            });
          });
      }
    }
    else {
      // upload-certificate
      this.file = event.target.files;
      const formData = new FormData();
      for (let x = 0; x < this.file.length; x++) {
        formData.append("file" + x, this.file[x]);
      }
      if (this.file.length > 0) {
        API.Instance.post("/api/assigned-courses/upload-certificate", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            this.$store.commit("AppStore/SNACK_BAR", {
              text: `File has been uploaded successfully!`,
              show: true,
            });
            this.file = null;
            this.certificates.push(response.data);
          })
          .catch(() => {
            this.$store.commit("AppStore/SNACK_BAR", {
              text: `Can't upload the given file, Please check the content!`,
              show: true,
            });
          });
      }
      console.log(this.certificates);
    }

  }

  public savenew() {
    console.log(this.items)
    this.loader = true;
    this.items.createdBy = 'Test';
    let files = "";
    // for (let i = 0; i < this.certificates.length; i++) {
    //   this.items.certificateurl = this.certificates[i];
    // }
console.log( this.items);

    API.Instance.post('/api/trainingplans/updateassignedcourses', this.items)
      .then((data) => {
        this.loader = false;
        this.loadData();
        this.$store.commit('AppStore/SNACK_BAR', {
        text: data.data,
        show: true,
      });

      })
  }  


  public save() {
    this.loader = true;
    this.items.createdBy = 'Test';
    let files = "";
    for (let i = 0; i < this.certificates.length; i++) {
      files += `${this.certificates[i]},`;
    }
    this.items.certificateUrl = files;
    API.Instance.post('/api/assigned-courses', this.items)
      .then((data) => {
        this.loader = false;
        this.load();
      })
  }
  public onClickToOpenLink(val:string){
    window.open(val,'blank')
    }

  public downloadReport() {
    this.loader = true;
    API.Instance
      .get('/api/trainingplans/report')
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/csv' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'LMS_Assigned_Data_Report.csv';
        link.click();
        this.loader = false;
      });
  }
}
